import React from 'react';

import './index.scss';

const Icon = ({ size = 'medium', icon }) => (
  <i className={icon}></i>
);

export default Icon;
